var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pb-0 mb-0 pt-0", attrs: { flat: "", "min-width": "100%" } },
    [
      _c(
        "div",
        [
          _c(
            "v-toolbar",
            {
              staticClass: "toolbar",
              staticStyle: { cursor: "default" },
              attrs: { flat: "" }
            },
            [
              _c("v-toolbar-title", { staticClass: "title" }, [
                _vm._v("Item Master")
              ]),
              _vm._v(" "),
              _c("v-divider", {
                staticClass: "mx-4",
                attrs: { inset: "", vertical: "" }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.$auth.tenant !== "alliance-retail-group" &&
                        _vm.hasWriteAccess,
                      expression:
                        "$auth.tenant !== 'alliance-retail-group' && hasWriteAccess"
                    }
                  ],
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({ name: "item" })
                    }
                  }
                },
                [_vm._v("\n        Create Item\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "ml-5 px-0",
                  staticStyle: { "max-width": "800px" }
                },
                [
                  _c("SearchFilters", {
                    attrs: {
                      disabled: _vm.loading,
                      originalUpc: _vm.originalUpc,
                      suggestedUpc: _vm.suggestedUpc
                    },
                    on: {
                      filterInput: _vm.handleFilterInput,
                      clearUpc: _vm.clearUpc,
                      updateUpc: _vm.updateUpc,
                      searchSimilar: function($event) {
                        return _vm.updateUpc(true)
                      }
                    },
                    model: {
                      value: _vm.searchParams,
                      callback: function($$v) {
                        _vm.searchParams = $$v
                      },
                      expression: "searchParams"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "pl-0", attrs: { cols: "auto" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: {
                        "border-top-left-radius": "0px",
                        "border-bottom-left-radius": "0px",
                        border: "1px solid #9e9e9e",
                        "border-left": "0px"
                      },
                      attrs: {
                        loading: _vm.loading,
                        disabled: _vm.noSearch,
                        depressed: "",
                        height: "40",
                        color: "accent"
                      },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.submitSearch($event)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("mdi-magnify")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.$auth.tenant === "jbg" && _vm.isRetailer
                ? _c(
                    "v-col",
                    { staticClass: "mr-4", attrs: { cols: "auto" } },
                    [
                      _c("v-switch", {
                        staticClass: "my-auto",
                        attrs: {
                          label: "Show discontinued items",
                          color: "primary",
                          "hide-details": "",
                          ripple: false
                        },
                        on: { change: _vm.showDiscontinuedItemsChange },
                        model: {
                          value: _vm.showDiscontinuedItems,
                          callback: function($$v) {
                            _vm.showDiscontinuedItems = $$v
                          },
                          expression: "showDiscontinuedItems"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$auth.tenant === "jbg"
                ? _c(
                    "v-col",
                    { staticClass: "ml-auto", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          on: {
                            click: function($event) {
                              _vm.showPriceHistoryModal = true
                            }
                          }
                        },
                        [
                          _vm._v("\n          Price History\n          "),
                          _c(
                            "v-icon",
                            { attrs: { right: "", size: "large" } },
                            [_vm._v("mdi-tag-outline")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              ["jbg", "alliance-retail-group"].includes(_vm.$auth.tenant)
                ? _c(
                    "v-col",
                    { staticClass: "my-0 py-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-menu",
                        {
                          attrs: { "open-on-hover": "", "offset-y": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            color: "primary",
                                            disabled:
                                              Object.entries(_vm.searchParams)
                                                .length === 0
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _vm._v(
                                          "\n              Export\n              "
                                        ),
                                        _c(
                                          "v-icon",
                                          {
                                            staticClass: "pl-2 pt-0",
                                            attrs: { size: "large" }
                                          },
                                          [
                                            _vm._v(
                                              "\n                mdi-download\n              "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1607891268
                          )
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-title",
                                    {
                                      staticClass: "grey--text text--darken-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                Select export type\n              "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleExportOptions("simple")
                                    }
                                  }
                                },
                                [_c("v-list-item-title", [_vm._v("Simple")])],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.handleExportOptions("detailed")
                                    }
                                  }
                                },
                                [_c("v-list-item-title", [_vm._v("Detailed")])],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.splashScreen
            ? _c("ItemMasterSplash", {
                on: { close: _vm.closeSplash },
                model: {
                  value: _vm.splashScreen,
                  callback: function($$v) {
                    _vm.splashScreen = $$v
                  },
                  expression: "splashScreen"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dataCon" },
            [
              _c(
                "v-form",
                { staticClass: "tableCon" },
                [
                  _c("v-data-table", {
                    attrs: {
                      id: "itemMaster",
                      height: _vm.tableSize,
                      headers: _vm.computedHeaders,
                      items: _vm.items,
                      loading: _vm.loading,
                      "item-key": "uuid",
                      "hide-default-footer": "",
                      "items-per-page": _vm.pageSize,
                      "no-data-text": _vm.noDataText,
                      "fixed-header": "",
                      dense: ""
                    },
                    on: {
                      "update:items": function($event) {
                        _vm.items = $event
                      },
                      "update:itemsPerPage": function($event) {
                        _vm.pageSize = $event
                      },
                      "update:items-per-page": function($event) {
                        _vm.pageSize = $event
                      },
                      "contextmenu:row": _vm.onRightClick,
                      "dblclick:row": _vm.viewItem
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "item.source_name",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c(
                                "span",
                                { staticClass: "text-no-wrap" },
                                [
                                  _vm.showDiscontinuedItems &&
                                  ["DISCONTINUED ITEM"].includes(item.status)
                                    ? _c(
                                        "v-tooltip",
                                        {
                                          staticClass: "mx-auto",
                                          attrs: { top: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function(ref) {
                                                  var on = ref.on
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        {
                                                          staticClass:
                                                            "pb-1 ml-n8",
                                                          attrs: {
                                                            icon: "",
                                                            small: "",
                                                            color: "warning"
                                                          }
                                                        },
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "mx-auto"
                                                          },
                                                          [_vm._v("mdi-alert")]
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        },
                                        [
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v("Item has been Discontinued")
                                          ])
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.source_name) +
                                      "\n            "
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        },
                        {
                          key: "item.sale_price",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("td", { staticClass: "text-no-wrap" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      item.sale_price == 0
                                        ? "-"
                                        : "" +
                                            (item.sale_price
                                              ? "$" + item.sale_price.toFixed(2)
                                              : "-")
                                    ) +
                                    "\n            "
                                )
                              ])
                            ]
                          }
                        },
                        {
                          key: "item.cost",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("td", { staticClass: "text-no-wrap" }, [
                                _vm._v(
                                  _vm._s(
                                    item.cost ? "$" + item.cost.toFixed(2) : "-"
                                  )
                                )
                              ])
                            ]
                          }
                        },
                        {
                          key: "item.weight",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("td", { staticClass: "text-no-wrap" }, [
                                _vm._v(
                                  _vm._s(
                                    item.weight ? item.weight.toFixed(2) : "-"
                                  )
                                )
                              ])
                            ]
                          }
                        },
                        {
                          key: "item.cube",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              _c("td", { staticClass: "text-no-wrap" }, [
                                _vm._v(
                                  _vm._s(item.cube ? item.cube.toFixed(2) : "-")
                                )
                              ])
                            ]
                          }
                        },
                        {
                          key: "item.components",
                          fn: function(ref) {
                            var item = ref.item
                            return [
                              Array.isArray(item.components) &&
                              item.components.length > 0
                                ? _c(
                                    "v-icon",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.openShipperModal(item)
                                        }
                                      }
                                    },
                                    [_vm._v("mdi-view-list")]
                                  )
                                : _vm._e()
                            ]
                          }
                        },
                        {
                          key: "footer",
                          fn: function() {
                            return [
                              _c("PagingFooter", {
                                attrs: {
                                  pageSizes: _vm.pageSizes,
                                  pageSize: _vm.pageSize,
                                  page: _vm.page,
                                  disablePrevious: _vm.disablePrevious,
                                  disableNext: _vm.disableNext
                                },
                                on: {
                                  "update:pageSize": function($event) {
                                    _vm.pageSize = $event
                                  },
                                  "update:page-size": function($event) {
                                    _vm.pageSize = $event
                                  },
                                  previous: _vm.previous,
                                  next: _vm.next
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("ShipperComponentModal", {
                attrs: { selectedItem: _vm.selectedItem },
                on: { closeDialog: _vm.closeShipperModal },
                model: {
                  value: _vm.shipperModal,
                  callback: function($$v) {
                    _vm.shipperModal = $$v
                  },
                  expression: "shipperModal"
                }
              }),
              _vm._v(" "),
              _vm.showDetailsModal
                ? _c("ExportDetailsModal", {
                    attrs: {
                      selectedItemDetails: _vm.selectedItemDetails,
                      isRetailer: _vm.isRetailer
                    },
                    on: {
                      "update:selectedItemDetails": function($event) {
                        _vm.selectedItemDetails = $event
                      },
                      "update:selected-item-details": function($event) {
                        _vm.selectedItemDetails = $event
                      },
                      exportItems: _vm.exportItems,
                      closeDialog: function($event) {
                        _vm.showDetailsModal = false
                      }
                    },
                    model: {
                      value: _vm.showDetailsModal,
                      callback: function($$v) {
                        _vm.showDetailsModal = $$v
                      },
                      expression: "showDetailsModal"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showPriceHistoryModal
                ? _c("PriceHistoryModal", {
                    on: {
                      closeDialog: function($event) {
                        _vm.showPriceHistoryModal = false
                      }
                    },
                    model: {
                      value: _vm.showPriceHistoryModal,
                      callback: function($$v) {
                        _vm.showPriceHistoryModal = $$v
                      },
                      expression: "showPriceHistoryModal"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-375f86a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-375f86a6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/itemMasterList.vue
// module id = null
// module chunks = 